<template>
  <div class="wrapper">
    <div class="page-box">
      <img class="no-page" src="../image/404.svg" />
      <div>
        <p class="tips">这次运气差，页面跑丢了</p>
        <el-button type="primary" @click="goBack()">返回重试</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    goBack() {
      this.$router.go(-1); //返回上一层
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.wrapper {
  height: 100%;
  width: 100%;
  .page-box {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .no-page {
    width: 50%;
  }
  .tips{
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/404.vue